module.exports = __webpack_public_path__ + "static/img/gongzhonghao.db6db73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gongzhonghao.png
// module id = FNDd
// module chunks = 16